import axios, { AxiosHeaders, AxiosInstance } from 'axios';
import { getDeviceId } from '../auth/deviceId';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: new AxiosHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Api-Key': process.env.NEXT_PUBLIC_API_KEY ?? '',
    'Device-Id': getDeviceId(),
    OS: 'windows',
    'App-Version': '1.0.0',
    // Local/testing only. Backend ignores these headers outside local/testing.
    ...(process.env.NODE_ENV !== 'production' &&
    process.env.NEXT_PUBLIC_SPOOF_COUNTRY
      ? {
          'X-Vercel-IP-Country': process.env.NEXT_PUBLIC_SPOOF_COUNTRY,
          'X-Country': process.env.NEXT_PUBLIC_SPOOF_COUNTRY,
        }
      : {}),
  }),
});

export default axiosInstance;
